import React from 'react';
import styles from './TermLengthCell.module.css';

type TProps = {
  value: string;
};

export const TermLengthCell = ({ value: termLength }: TProps) => {
  const renderTermLength = () => {
    return (
      <div>
        {termLength.split(',').map((term, i) => (
          <span key={`${term}-${i}`} className={styles.termLength}>
            {term}
          </span>
        ))}
      </div>
    );
  };

  return <div data-testid="term-length-cell">{renderTermLength()}</div>;
};
